const MultiToSingleFamilyConversion = ({ convertedFromListingAlias = '', isConversionRequired = false }) => ({
  convertedFromListingAlias: String(convertedFromListingAlias),
  isConversionRequired: Boolean(isConversionRequired),
});

export default MultiToSingleFamilyConversion;

export type MultiToSingleFamilyConversionProps = ReturnType<typeof MultiToSingleFamilyConversion>;
